import StaticStickitView from './static_stickit_view';

export default StaticStickitView.extend({
  // A view for selecting which of your dogs to search for
  bindings: {
    '.js-pet-checkbox': 'pet',
  },

  initialize() {
    // If we have specified the active pets, then we don't
    // need to do anything else
    if (!this.model.get('pet')) {
      // By default, check all of the available pets
      const petInputs = this.$el.find('input[name=pet]');
      this.model.set(
        {
          pet: _.map(petInputs, checkbox => parseInt($(checkbox).val(), 10)),
        },
        { silent: true }
      );
    }

    StaticStickitView.prototype.initialize.call(this);
  },
});



// WEBPACK FOOTER //
// ./js/backbone/views/dog_selection_view.js